module.exports = __webpack_public_path__ + "img/banner1.414b582a.png";